<div class="matching-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Missing Matching -->
  <div class="matching-card">
    <div class="card-header">
      <span class="status-dot red"></span>
      <h3 class="card-title">Missing Matching</h3>
    </div>
    <div class="bar-list">
      <div class="bar-row" *ngFor="let item of missingMatching | slice:0:5">
        <span class="bar-label" [title]="item.ecuBuild">{{ item.ecuBuild }}</span>
        <div class="bar-track">
          <div class="bar-fill red-fill"
               [style.width.%]="getBarWidth(item.count, missingMatching)">
          </div>
        </div>
        <span class="bar-value">{{ item.count | number }}</span>
      </div>
    </div>
  </div>

  <!-- Partial Matching -->
  <div class="matching-card">
    <div class="card-header">
      <span class="status-dot amber"></span>
      <h3 class="card-title">Partial Matching</h3>
    </div>
    <div class="bar-list">
      <div class="bar-row" *ngFor="let item of partialMatching | slice:0:5">
        <span class="bar-label" [title]="item.ecuBuild">{{ item.ecuBuild }}</span>
        <div class="bar-track">
          <div class="bar-fill amber-fill"
               [style.width.%]="getBarWidth(item.count, partialMatching)">
          </div>
        </div>
        <span class="bar-value">{{ item.count | number }}</span>
      </div>
    </div>
  </div>

  <!-- Successful Matching -->
  <div class="matching-card">
    <div class="card-header">
      <span class="status-dot green"></span>
      <h3 class="card-title">Successful Matching</h3>
    </div>
    <div class="bar-list">
      <div class="bar-row" *ngFor="let item of successfulMatching | slice:0:5">
        <span class="bar-label" [title]="item.ecuBuild">{{ item.ecuBuild }}</span>
        <div class="bar-track">
          <div class="bar-fill green-fill"
               [style.width.%]="getBarWidth(item.count, successfulMatching)">
          </div>
        </div>
        <span class="bar-value">{{ item.count | number }}</span>
      </div>
    </div>
  </div>
</div>
